
import { Component, Vue, Prop, Watch, VModel } from 'vue-property-decorator';
import CountryFlag from 'vue-country-flag';
import { GlobalVariables } from '@/libs/core/global';
import moment from 'moment/moment';

@Component({
    components: {
        CountryFlag,
    },
})
export default class FlagSelect extends Vue {
    items = [
        { id: 'cs', flag: 'cz', value: 'Čeština' },
        { id: 'en', flag: 'gb', value: 'English' },
        { id: 'uk', flag: 'ua', value: 'Ukrainian' },
        { id: 'zh-cn', flag: 'cn', value: 'Chinese' },
        { id: 'de', flag: 'de', value: 'German' },
        { id: 'es', flag: 'es', value: 'Spanish' },
        { id: 'it', flag: 'it', value: 'Italian' },
        { id: 'fr', flag: 'fr', value: 'French' },
        { id: 'hu', flag: 'hu', value: 'Hungarian' },
    ];

    @VModel() innerValue: any;

    @Prop() label!: string;
    @Prop() itemText!: string;
    @Prop() itemValue!: string;
    @Prop({ default: true }) enabled!: boolean;
    @Prop() readonly!: boolean;
    @Prop() clearable!: boolean;
    @Prop() rules!: [any[]];
    @Prop({ default: false }) required!: boolean;
    @Prop() placeholder!: string;
    @Prop({ default: false }) hideDetails!: boolean;
    @Prop({ default: false }) showText!: boolean;
    @Prop({ default: true }) immediateChange!: boolean;

    @Watch('innerValue')
    innerValueChanged(v: string, p: string) {
        if (v != null && v != p && this.immediateChange) {
            this.$i18n.locale = this.innerValue;
            window.localStorage.language = v;
            this.$vuetify.lang.current = v;
            GlobalVariables.lang = v;
            moment.locale(this.$vuetify.lang.current);
        }
    }
}
